import React from "react";
import { Link } from "react-router-dom";

const LinkButton = ({ buttonText, className, to, href }) => {
  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`border border-light-green-500 bg-light-green-500 hover:bg-light-green-600 text-green-800 font-semibold py-3 px-8 transition duration-300 ease-in-out transform text-sm w-full lg:w-fit block text-center ${className}`}
      >
        {buttonText}
      </a>
    );
  }
  return (
    <Link
      to={to}
      className={`border border-light-green-500 bg-light-green-500 hover:bg-light-green-600 text-green-800 font-semibold py-3 px-8 transition duration-300 ease-in-out transform text-sm w-full lg:w-fit block text-center ${className}`}
    >
      {buttonText}
    </Link>
  );
};

export default LinkButton;
